import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  // faqData = null,
  constituencyListData = null,
  candidateProfileData = null,
  candidateList = null,
  constituencyName = null,
  ConstituencyliveBlogData = null
}) {
  const isMobileDevice = useIsMobile();
  // console.log("candidateProfileData", candidateProfileData);
  const constituencyNameHindi=candidateList?.constituency_name_h
  const constituencyNameCapitalCase=constituencyName?.charAt(0).toUpperCase() + constituencyName?.slice(1)?.toLowerCase();
  
 let metaData = {
    title:  `${candidateProfileData?.candidate}  Performance in ${constituencyNameCapitalCase} Assembly Result 2026: ${constituencyNameHindi} विधानसभा सीट से ${candidateProfileData?.candidate_h} उम्मीदवार की स्थिति, वोट शेयर और लेटेस्ट अपडेट – NewsTak`,
    description: `${candidateProfileData?.candidate} ${constituencyNameCapitalCase} Vidhan Sabha Chunav Result 2026: जानें  विधानसभा सीट ${constituencyNameHindi} से ${candidateProfileData?.candidate_h} का चुनाव परिणाम, जीत-हार का मार्जिन, वोट शेयर और हर अपडेट, ${constituencyNameCapitalCase} ${constituencyNameCapitalCase} Assembly Election 2026 के लेटेस्ट रिजल्ट देखें सिर्फ NewsTak.in पर.`,
    keywords:  `${candidateProfileData?.candidate} , ${constituencyNameCapitalCase} Vidhan Sabha Chunav Result 2026, ${constituencyNameCapitalCase} Election Result 2026, ${constituencyNameCapitalCase} Assembly Election 2026, ${constituencyNameCapitalCase} Vidhan Sabha Chunav, ${constituencyNameCapitalCase} Election Result Live, ${constituencyNameCapitalCase} seat result, ${constituencyNameCapitalCase} election winner 2026, ${constituencyNameCapitalCase} ${candidateProfileData?.party} candidate, केरल विधानसभा चुनाव 2026, ${constituencyNameHindi} विधानसभा रिजल्ट, ${candidateProfileData?.candidate_h} चुनाव परिणाम`

  };
 
return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath={"delhi-assembly/schedule"}
          electionPath={`${electionCategory}/candidates/`}
        ConstituencyliveBlogData={ConstituencyliveBlogData}
          isMobileDevice={isMobileDevice}
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="kerala_election"
          stateName={"Kerala"} //"Delhi"
          stateHindi={"केरल"}
          metaData={metaData}
          constituencyListData={constituencyListData}
          candidateProfileData={candidateProfileData}
          candidateList={candidateList}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  let url2 = "/elections/assembly-chunav/kerala";
  let url = ctx?.resolvedUrl;
  url = url.split("?")[0];

  const [candidateName, constituencyID, candidateID] = url
    .split("/")
    .pop()
    .split("-result-")
    .map(
      (p, i) =>
        i === 0
          ? p
              .split("-")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(" ")
          : p.split("-").slice(-2) // Get last two parts for constituency & candidate ID
    )
    .flat();
  let electionCategory ="assembly-chunav/kerala";
// console.log("electionCategory11", electionCategory);
  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url2,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.kerala_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
        ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1 || null; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    }).catch((err) => {
      logger.error("Error fetching constituency list data:", err);
      constituencyListData = null;
    });

    let constId = constituencyID; // url?.split("-").pop();
    let constituencyName = null;
    let candidateProfileData = null;
    let candidateList = null;
    let candidateUrl = electionConfigData?.isElectionAlpha
      ? // ? `https://electionresults.intoday.in/elections/2025/assembly-elections/json/constituency-alpha/${id}.json`
        `https://electionresults.intoday.in/elections/2026/assembly-elections/json/constituency-alpha/kerala/${constId}.json`
      : `https://electionresults.intoday.in/elections/2026/assembly-elections/json/constituency-tak/kerala/${constId}.json`;
     
   
     await fetch(candidateUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const tempCand = await data.json();
      constituencyName = tempCand?.data?.constituency_name;
      candidateList = tempCand?.data;
 
      candidateProfileData =
        tempCand?.data.candidate?.find((c) => {
          // const isDuplicateID = duplicateIDs.includes(candidateID);
          return c?.id?.toString() == candidateID?.toString();
          //  && c?.candidate?.toLowerCase() == candidateName?.toLowerCase()
          // return isDuplicateID
          //   ? c?.id?.toString() === candidateID?.toString() && c?.candidate?.toLowerCase() === candidateName?.toLowerCase()
          //   : c?.candidate?.toLowerCase() === candidateName?.toLowerCase();
        }) || null;
    }).catch((err) => {
      logger.error("Error fetching candidate data:", err);
      candidateProfileData = null;
       constituencyName = null;
       candidateList = null;});

       // constituency live blog api-----------------------------------------------
    let ConstituencyliveBlogData = null;
    let ConstituencyliveBlogUrl = `${process.env.BASE_PATH}/nwtak/api/get-election-constituency-data?id=${constId}`;

    try {
      const response = await fetch(ConstituencyliveBlogUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const tempCand = await response.json();

      if (tempCand?.status_code === 0 || !tempCand?.data) {
        ConstituencyliveBlogData = null;
      } else {
        ConstituencyliveBlogData = tempCand.data;
      }
    } catch (err) {
      console.error(err);
      ConstituencyliveBlogData = null;
    }

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url2,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 120);
// console.log("candidateProfileData", candidateProfileData);
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory: electionCategory,
        // faqData,
        constituencyListData,
        candidateProfileData,
        candidateList,
        constituencyName,
        ConstituencyliveBlogData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
